module.exports = __webpack_public_path__ + "media/images/kids8-c8eb324b84d2bcbc55e36bf1e83e5ca7.jpg";